import React from 'react'
import { DetailSupport } from './DetailSupport'

export const ConsiderSupport = ({ supportId, supportTypeId }) => {

    return (
        <div>
            <DetailSupport supportId={supportId} />
           
        </div>
    )
}
